import React, { useEffect, useState } from "react";
import "./othersmodule.css";
import instance from "../../ApiInstance/Inetrceptor";
import StyledTableCell from "../../Tabletheme/Customtableheader";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  TableFooter,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import StatisDialog from "./StatisDialog";
import CustomPagination from "../common/CustomPagination ";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

const Statistics = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dialogLoading, setDialogLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showError, setShowError] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogData, setDialogData] = useState(null);
  const [selectedTB, setSelectedTB] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isFiltered, setIsFiltered] = useState(false);
  const [dialogTBOpen, setDialogTBOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecods, setTotalRecods] = useState(0);
  const [getDeamonInfo, setGetDeamonInfo] = useState("");
  const totalPages = Math.ceil(totalRecods / 50);
  const [truckerId, setTruckerId] = useState(null);
  const [totalflag, setTotalflag] = useState(false);
  const [utcNow, setUtcNow] = useState(null);
  const pageSize = 50;

  const getAnalytics = (truckerId, fromDate, toDate, analyticscon, flag) => {
    let body = {
      truckerid: truckerId || "",
      analyticscon: analyticscon,
      fromdate: fromDate || "",
      todate: toDate || "",
      currentPage: currentPage,
      pageSize: pageSize,
    };

    instance
      .post("api/v1/Analytics/GetAnalyticBasedonTruckerId", body)
      .then((res) => {
        if (res.data.Success) {
          setTotalRecods(res?.data?.Records ?? 0);
          if (truckerId !== null || flag !== null) {
            setDialogData(res.data.Value); // Set dialogData if truckerId or flag is provided
          } else {
            setData(res.data.Value); // Set main data if neither truckerId nor flag is provided
          }
        } else {
          setTotalRecods(0);
          setError(res.data.ResultMessage);
        }
      })
      .catch((err) => {
        setError(err.message);
      })
      .finally(() => {
        setLoading(false);
        setDialogLoading(false);
      });
  };
  const GetDeamonMetaInfo = () => {
    instance
      .get("api/v1/Middleware/GetDeamonMetaInfo")
      .then((res) => {
        if (res.data.Success) {
          setGetDeamonInfo(res?.data?.Value);
          setUtcNow(new Date().toISOString());
        } else {
          setError(res.data._ResultMessage);
        }
      })
      .catch((err) => {
        setError(err.message);
      })
      .finally(() => {
        setLoading(false);
        setDialogLoading(false);
      });
  };
  const handleRefreshClick = async () => {
    GetDeamonMetaInfo();
  };
  useEffect(() => {
    GetDeamonMetaInfo();
  }, []);
  useEffect(() => {
    const filterFromDate = isFiltered ? fromDate : "";
    const filterToDate = isFiltered ? toDate : "";
    if (totalflag) {
      getAnalytics(null, filterFromDate, filterToDate, "", totalflag);
    } else if (truckerId !== null) {
      getAnalytics(truckerId, filterFromDate, filterToDate, "", null);
    } else {
      getAnalytics(null, filterFromDate, filterToDate, "1", null);
    }
  }, [currentPage, totalflag, truckerId]);

  const handleCellClick = (truckerId) => {
    // setDialogLoading(true);
    setDialogOpen(true);
    const filterFromDate = isFiltered ? fromDate : "";
    const filterToDate = isFiltered ? toDate : "";
    setTotalflag(false);
    setCurrentPage(1);
    setTruckerId(truckerId);
    // getAnalytics(truckerId, filterFromDate, filterToDate, "", null);
  };

  const handleCellTBClick = (TBnumber) => {
    setSelectedTB(TBnumber);
    setDialogTBOpen(true);
  };

  const handleDialogTBClose = () => {
    setDialogTBOpen(false);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleFilterSubmit = () => {
    if (!fromDate || !toDate) {
      setError("Both 'From Date' and 'To Date' must be filled.");
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 5000);
      return;
    }
    if (new Date(toDate) < new Date(fromDate)) {
      setError("'To Date' should be after 'From Date'.");
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 5000);
      return;
    }
    setIsFiltered(true);
    // if(truckerId===null){
    //   getAnalytics(truckerId, fromDate, toDate, "1",null);
    //      }else{
    //        getAnalytics(truckerId, fromDate, toDate, "");
    //      }
    getAnalytics(null, fromDate, toDate, "1", null);
  };

  const handleUnfilter = () => {
    setError(null);
    setIsFiltered(false);
    setFromDate("");
    setToDate("");
    getAnalytics();
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleTotalClick = (Total) => {
    console.log("Handling total click with flag:", Total);
    setDialogOpen(true);
    const filterFromDate = isFiltered ? fromDate : "";
    const filterToDate = isFiltered ? toDate : "";
    const flag = Total;
    setTruckerId(null); // Set truckerId to null for total view
    setCurrentPage(1); // Reset to first page
    setTotalflag(Total);
    // getAnalytics(null, filterFromDate, filterToDate, "", Total);
  };

  const totalJobReferences = data.reduce(
    (sum, item) => sum + item.TotalJobReference,
    0
  );
  const getPageStartingSerial = (page) => {
    return (page - 1) * pageSize + 1;
  };
  
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }
  return (
    <>
      <Typography variant="h4" align="center" gutterBottom>
        Analytics Data
      </Typography>
      <Box
        sx={{
          padding: "50px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {/* Date Fields */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ display: "flex", gap: 2 }}>
            <TextField
              label="From Date"
              type="date"
              size="small"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              label="To Date"
              type="date"
              size="small"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
            <div style={{ display: "flex" }}>
              <div
                className={`message_div ${
                  isFiltered ? "background_FilterIcon" : ""
                }`}
                onClick={handleFilterSubmit}
              >
                <FilterAltIcon sx={{ fontSize: "small" }} />
              </div>
              <div className="message_div" onClick={handleUnfilter}>
                <FilterAltOffIcon sx={{ fontSize: "small" }} />
              </div>
            </div>
          </Box>
          <Typography
            variant="h7"
            color="error"
            sx={{
              justifyContent: "left",
              padding: "0px 0px 0 7px",
              fontSize: "md",
            }}
          >
            {showError && error}
          </Typography>
        </Box>
        {/* Wildcard Filter */}
        <Box
          sx={{
            position: "absolute",
            top: "50px",
            right: "50px",
            padding: "20px",
            backgroundColor: "#f0f0f0",
          }}
        >
          {/* <Typography
            sx={{
              marginRight: 3,
              fontSize: 'var(--fs-new)',
              color: 'var(--color-selectedRowText)',
              fontWeight: 'bold',
            }}
            mb={1}
          >
            Wildcard Filter
          </Typography> */}
          <Box sx={{ position: "absolute", top: 0, right: 0 }}>
            <IconButton onClick={handleRefreshClick}>
              <RestartAltIcon />
            </IconButton>
          </Box>
          <Box display="flex" alignItems="center" sx={{ mt: 2 }}>
            <div className="d-flex flex-column" style={{ rowGap: "0.5rem" }}>
              <div className="d-flex">
                <Typography
                  sx={{
                    marginRight: 3,
                    flex: 1,
                    fontSize: "var(--fs-small)",
                  }}
                >
                  UTC Now
                </Typography>
                <Typography
                  sx={{
                    //  marginRight: 2,
                    marginLeft: 5,

                    fontSize: "var(--fs-small)",
                  }}
                >
                  {utcNow}
                </Typography>
              </div>

              <div className="d-flex">
                <Typography
                  sx={{
                    marginRight: 3,
                    flex: 1,
                    fontSize: "var(--fs-small)",
                  }}
                >
                  Fetch Last Updated
                </Typography>
                <Typography
                  sx={{
                    // marginRight: 3,
                    marginLeft: 5,
                    // flex: 1,
                    fontSize: "var(--fs-small)",
                  }}
                >
                  {getDeamonInfo?.fetchdeamonlastrun}
                </Typography>
              </div>
              <div className="d-flex">
                <Typography
                  sx={{
                    marginRight: 3,
                    flex: 1,
                    fontSize: "var(--fs-small)",
                  }}
                >
                  Relay Last Updated
                </Typography>
                <Typography
                  sx={{
                    // marginRight: 3,
                    marginLeft: 5,
                    // flex: 1,
                    fontSize: "var(--fs-small)",
                  }}
                >
                  {getDeamonInfo?.relaydeamonlastrun}
                </Typography>
              </div>
            </div>
          </Box>
        </Box>
      </Box>
      <TableContainer
        sx={{ maxHeight: 600, width: "95%", mt: 1, ml: 5 }}
        component={Paper}
      >
        <Table stickyHeader sx={{ width: "100%" }}>
          <TableHead>
            <TableRow className="Table_rowOthr">
              <StyledTableCell>SNo</StyledTableCell>
              <StyledTableCell>Trucker Name</StyledTableCell>
              <StyledTableCell>Total Job Reference</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  No data found
                </TableCell>
              </TableRow>
            ) : (
              data.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{item.Trucker_Name}</TableCell>
                  <TableCell
                    onClick={() => handleCellClick(item.trucker_id)}
                    sx={{ cursor: "pointer", color: "blue" }}
                  >
                    {item.TotalJobReference}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TableCell colSpan={2} align="right">
                <strong>Total</strong>
              </TableCell>
              <TableCell
                onClick={() => handleTotalClick("TOTAL")}
                sx={{ cursor: "pointer", color: "blue" }}
              >
                <strong>{totalJobReferences}</strong>
              </TableCell>
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>

      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        maxWidth="lg"
        fullWidth
        maxHeight="sm"
      >
        <DialogTitle>
          <IconButton
            aria-label="close"
            style={{ position: "absolute", right: 10, top: 5 }}
            onClick={handleDialogClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent style={{ padding: 10 }}>
        <div style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: 'white', padding: '16px 24px' }}>
          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
          <Typography
            sx={{ fontSize: "var(--fs-medium)", marginRight: "0rem" }}
          >
            Total Recods - {totalRecods}
          </Typography>
          <div style={{ maxHeight: '700px', overflowY: 'auto' }}>
          {dialogLoading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Table stickyHeader>
              <TableHead >
                <TableRow>
                  <TableCell>SNo</TableCell>
                  <TableCell>Transport Booking</TableCell>
                  <TableCell>Trucker ID</TableCell>
                  <TableCell>Trucker Name</TableCell>
                  <TableCell>BatchNumber</TableCell>
                  <TableCell>Status Code</TableCell>
                  <TableCell>Original Message Identifier</TableCell>
                  <TableCell>Is Custom Clearance</TableCell>
                  <TableCell>Reference Number</TableCell>
                  <TableCell>Updation Count</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dialogData && dialogData.length > 0 ? (
                  dialogData &&
                  dialogData.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{getPageStartingSerial(currentPage) + index}</TableCell>
                      <TableCell
                        onClick={() => handleCellTBClick(item.job_reference)}
                        sx={{ cursor: "pointer", color: "blue" }}
                      >
                        {item.job_reference}
                      </TableCell>
                      <TableCell>{item.trucker_id}</TableCell>
                      <TableCell>{item.Trucker_Name}</TableCell>
                      <TableCell>{item.BatchNumber}</TableCell>
                      <TableCell>
                        {item.current_response_msg_status_code}
                      </TableCell>
                      <TableCell>
                        {item.original_message_identifier_FK}
                      </TableCell>
                      <TableCell>{item.IsCustomClearance}</TableCell>
                      <TableCell>{item.console_reference_number}</TableCell>
                      <TableCell>{item.UpdationCount}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={10} sx={{ textAlign: "center" }}>
                      No data found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          )}
          </div>
          </div>
        </DialogContent>
      </Dialog>

      <StatisDialog
        open={dialogTBOpen}
        setDialogOpen={setDialogTBOpen}
        handleClose={handleDialogTBClose}
        dialogData={dialogData}
        loading={loading}
        selectedTB={selectedTB}
      />
    </>
  );
};

export default Statistics;
